/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class LocalDateFilter {
    public static filter(): any {
        return (input: string): string => {
            return input != undefined ? new Date(input).toLocaleDateString().replace(/\//g,".") : ''
        };
    }
}


angular.module('beneple.global')
    .filter('localdate', LocalDateFilter.filter);



// WEBPACK FOOTER //
// ./frontend/scripts/global/filters/localdate.filter.ts